(function($){
    if ($('.infoSlides').length > 0) {
        let leftArrow = $('.left-arrow');
        let rightArrow = $('.right-arrow');

        let infoSlides = $('.infoSlides');
        let secondInfoSlide = $('.show-second-slide');
        let firstInfoSlide = $('.show-first-slide');

        $(infoSlides[0]).addClass('activeSlide');
        
        function showSlide(next) {
            let currentSlide = $('.infoSlides.activeSlide');
            let indexCurrent = infoSlides.index(currentSlide);
            let slidesLength = infoSlides.length - 1;

            let showIncrement =  next ? 1 : -1;

            if(indexCurrent == 0 && next == false) {

                infoSlides[indexCurrent].style.display = "none";
                currentSlide.removeClass("activeSlide");
                let lastSlide = infoSlides[slidesLength];
                lastSlide.style.display = "block"
                $(lastSlide).addClass("activeSlide");

            } else if (indexCurrent == slidesLength && next == true) {

                infoSlides[indexCurrent].style.display = "none";
                currentSlide.removeClass("activeSlide");
                infoSlides[0].style.display = "block"
                $(infoSlides[0]).addClass("activeSlide");

            } else {
                let nextSlide = infoSlides[indexCurrent + showIncrement];
                infoSlides[indexCurrent].style.display = "none";
                currentSlide.removeClass("activeSlide");
                nextSlide.style.display = "block";
                $(nextSlide).addClass("activeSlide");

            }

            let firstslide = currentSlide.find('.first-slide');
            firstslide.show();
            let secondslide = currentSlide.find('.second-slide');
            secondslide.hide();

        }

        function showSecondSlide() {
            let activeSlide = $('.infoSlides.activeSlide');
            let firstslide = activeSlide.find('.first-slide');
            let secondslide = activeSlide.find('.second-slide');

            firstslide.hide();
            secondslide.show();
        }

        function showFirstSlide() {
            let activeSlide = $('.infoSlides.activeSlide');
            let firstslide = activeSlide.find('.first-slide');
            let secondslide = activeSlide.find('.second-slide');

            firstslide.show();
            secondslide.hide();
        }
            

        rightArrow.on('click', function(){
            let next = true;
            showSlide(next);
        });
        leftArrow.on('click', function(){
            let next = false;
            showSlide(next);
        });


        secondInfoSlide.on('click', showSecondSlide);
        firstInfoSlide.on('click', showFirstSlide);

    }
    
})(jQuery);
